import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import CheckBlockGroup from 'components/consumer/CheckBlockGroup';
const MobileTierFilters = t0 => {
  const $ = _c(9);
  const {
    fabricTiers,
    toggleSelectedTier,
    selectedTiers
  } = t0;
  let t1;
  if ($[0] !== fabricTiers || $[1] !== selectedTiers || $[2] !== toggleSelectedTier) {
    let t2;
    if ($[4] !== selectedTiers || $[5] !== toggleSelectedTier) {
      t2 = tier => ({
        label: `Tier ${tier}`,
        id: tier,
        isSelected: selectedTiers.includes(tier),
        description: {
          1: "Readily available fabrics that bring an eye-catching look to your piece at a great value.",
          2: "Kick things up a notch with fabrics that show off more rich colors, textures, and durability.",
          3: "Got an active home? Check out these fabrics that showcase top notch performance finishes while still looking stylish.",
          4: "As luxe as it gets, this tier includes our branded performance fabrics and stain resistant finish fabrics, ready to take on all life throws its way in sophisticated style."
        }[tier],
        onClick: () => {
          toggleSelectedTier(tier);
        }
      });
      $[4] = selectedTiers;
      $[5] = toggleSelectedTier;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = fabricTiers.map(t2);
    $[0] = fabricTiers;
    $[1] = selectedTiers;
    $[2] = toggleSelectedTier;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ShopByHeaderSection label="Tier"><CheckBlockGroup items={t1} /></ShopByHeaderSection>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
MobileTierFilters.propTypes = {
  fabricTiers: PropTypes.node,
  toggleSelectedTier: PropTypes.func,
  selectedTiers: PropTypes.node
};
export default MobileTierFilters;